import styled from 'styled-components';
import { color } from 'styles/pallete';

interface ContainerProps {
	$pTop: number;
	$pBottom: number;
}

export const container = styled.div<ContainerProps>`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	padding: ${(props) => (props.$pTop === 0 ? '10px' : `${props.$pTop}px`)} 0px
		${(props) => (props.$pBottom === 0 ? '10px' : `${props.$pBottom}px`)} 10px;
`;

export const list = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	overflow: auto;
	gap: 1rem;
`;

export const link = styled.div`
	min-width: fit-content;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	padding: 0.5rem 0rem;
	/* border: 1px solid ${color.interface.lightGray};
	border-radius: 10px; */

	> p {
		font-size: 1.3rem;
		color: ${color.interface.black};
	}
`;
